export default "__VITE_ASSET__f93606ee__"